<template>
  <v-list
    id="dashboard-menu"
    class="sidebar-menu is-active animated preFadeInRIght fadeInRight"
  >
    <MainMenuEntry
      v-for="entry in menuEntries"
      :key="entry.location.name"
      :icon-name="entry.iconName"
      :text="entry.text"
      :location="entry.location"
    />
  </v-list>
</template>

<script setup lang="ts">
import { brelagSupporterRouteName } from '@/apps/brelag/brelag-supporter/app'
import MainMenuEntry from '@/components/navigation/MainMenuEntry.vue'
import { i18n } from '@/lang/setup'

const menuEntries = [
  {
    iconName: 'mdi-account-group',
    text: i18n.global.t('apps.brelag.mandator', 2),
    location: { name: brelagSupporterRouteName('mandator-root') },
  },
  {
    iconName: 'mdi-folder-multiple',
    text: i18n.global.t('apps.brelag.project', 2),
    location: { name: brelagSupporterRouteName('project-list') },
  },
  {
    iconName: 'mdi-import',
    text: i18n.global.t('apps.brelag.projectImport', 2),
    location: { name: brelagSupporterRouteName('legacy-project-import') },
  },
  {
    iconName: 'mdi-key',
    text: i18n.global.t('apps.brelag.knockautLicenseKey', 2),
    location: {
      name: brelagSupporterRouteName('knockaut-license-key-root'),
    },
  },
  {
    iconName: 'mdi-memory',
    text: i18n.global.t('apps.brelag.knockautDashboard', 2),
    location: { name: brelagSupporterRouteName('knockaut-dashboard') },
  },
  {
    iconName: 'mdi-auto-fix',
    text: i18n.global.t('apps.brelag.knockautXProgrammers', 2),
    location: { name: brelagSupporterRouteName('knockautx-programmers') },
  },
]
</script>
